export const defaultGuestsAndRooms = () => ({
  numberOfAdults: 2,
  numberOfRooms: 1,
});
